/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetModifiers200ResponseItemsInner } from './GetModifiers200ResponseItemsInner';
import {
    GetModifiers200ResponseItemsInnerFromJSON,
    GetModifiers200ResponseItemsInnerFromJSONTyped,
    GetModifiers200ResponseItemsInnerToJSON,
    GetModifiers200ResponseItemsInnerToJSONTyped,
} from './GetModifiers200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetModifiers200Response
 */
export interface GetModifiers200Response {
    /**
     * 
     * @type {Array<GetModifiers200ResponseItemsInner>}
     * @memberof GetModifiers200Response
     */
    items: Array<GetModifiers200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetModifiers200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifiers200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifiers200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetModifiers200Response interface.
 */
export function instanceOfGetModifiers200Response(value: object): value is GetModifiers200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetModifiers200ResponseFromJSON(json: any): GetModifiers200Response {
    return GetModifiers200ResponseFromJSONTyped(json, false);
}

export function GetModifiers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifiers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetModifiers200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetModifiers200ResponseToJSON(json: any): GetModifiers200Response {
    return GetModifiers200ResponseToJSONTyped(json, false);
}

export function GetModifiers200ResponseToJSONTyped(value?: GetModifiers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetModifiers200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

